import { render, staticRenderFns } from "./WorkflowCheckboxField.vue?vue&type=template&id=bb6900b4&lang=pug&"
import script from "./WorkflowCheckboxField.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkflowCheckboxField.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports